import { createRouter, createWebHistory } from 'vue-router';
import { handleHotUpdate, routes } from 'vue-router/auto-routes';
import { trxLegacyDestination } from '@/utils/trxNavigation';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.beforeEach((to, from) => {
  if (to.path === '/') {
    return { path: '/trx', replace: true };
  }
  const destination = trxLegacyDestination(to.path);
  if (destination) return { ...destination, replace: true };
  const botStore = useBotStore();
  // Persisting a tab/result in the query must not repeat full bot initialization.
  if (to.path !== from.path || !botStore.hasBots) initBots();
  if (!to.meta?.allowAnonymous && !botStore.hasBots) {
    // Forward to login if login is required
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    };
  } else {
    return true;
  }
});

if (import.meta.hot) {
  handleHotUpdate(router);
}

export default router;
